import Button from 'components/generic-components/thera-start-components/Button';
import { GoArrowLeft } from 'react-icons/go';
import { options } from 'lib/theraStartConstants';

export default function EINDocumentsStep({ formik, onNext, onBack }) {
  // Ensure einDocuments is always an array
  const selected = Array.isArray(formik.values.einDocuments) ? formik.values.einDocuments : [];

  const handleToggle = (value) => {
    let newSelected;
    if (selected.includes(value)) {
      newSelected = selected.filter((v) => v !== value);
    } else {
      newSelected = [...selected, value];
    }
    formik.setFieldValue('einDocuments', newSelected);
  };

  return (
    <div className="relative flex flex-col items-center justify-center bg-[#181818] px-4 py-8">
      {/* Back Button */}
      <div className="max-w-1xl mb-4 w-full">
        <button
          type="button"
          onClick={onBack}
          className="mb-2 flex items-center gap-2 font-semibold text-white transition-colors hover:text-blue-500"
        >
          <GoArrowLeft size={18} />
          <span>Back</span>
        </button>
      </div>

      {/* Card */}
      <div className="max-w-1xl flex w-full flex-col justify-between rounded-2xl bg-white p-6 shadow-xl sm:p-8 md:p-10">
        <div>
          <h2 className="mb-1 text-[1.5rem] font-[600] text-dark">Build your business identity</h2>
          <p className="mb-6 text-[1rem] text-[#191919B3]">
            Get a domain name, website, email address, and phone number for your business in minutes.
          </p>

          <div className="mb-8 flex flex-col gap-6">
            {options.map((opt) => (
              <label key={opt.value} className="flex cursor-pointer select-none items-center gap-5">
                {/* Toggle Switch */}
                <span
                  className={`relative inline-block h-7 w-11 transition-colors duration-200 ${selected.includes(opt.value) ? 'bg-[#181818]' : 'bg-[#E5E7EB]'} rounded-full`}
                  style={{ minWidth: '40px' }}
                >
                  <input
                    type="checkbox"
                    checked={selected.includes(opt.value)}
                    onChange={() => handleToggle(opt.value)}
                    className="absolute left-0 top-0 z-10 h-full w-full cursor-pointer opacity-0"
                    aria-checked={selected.includes(opt.value)}
                  />
                  <span
                    className={`absolute left-1 top-1 h-5 w-5 rounded-full bg-white shadow transition-transform duration-200 ${selected.includes(opt.value) ? 'translate-x-4' : ''}`}
                  ></span>
                </span>
                <span className="text-[1.35rem] font-semibold leading-tight text-[#191C23]">{opt.label}</span>
                <span className="ml-auto text-[1.08rem] font-[600] text-[#2571CF]">${opt.price}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="mt-2 flex flex-col gap-3">
          <Button
            className="w-full rounded-lg !bg-black py-3 text-[1rem] font-semibold !text-white transition-colors hover:!bg-gray-900 disabled:cursor-not-allowed disabled:opacity-50"
            onClick={() => onNext()}
            disabled={selected.length === 0}
          >
            Continue
          </Button>
          <Button
            variant="white"
            className="w-full rounded-lg border border-black bg-white py-3 text-[1rem] font-semibold text-black transition-colors hover:bg-gray-100"
            onClick={() => {
              formik.setFieldValue('einDocuments', []);
              onNext();
            }}
          >
            Skip
          </Button>
        </div>
      </div>
    </div>
  );
}
